enum ValidationState {
    ToValidate,
    Refused,
    Validated,
    ManuallyCompleted,
}

export default ValidationState;
